import { Container } from "react-bootstrap";

function Datenschutz() {
  return (
    <>
      <Container style={{ padding: "60px 0", maxWidth: "960px" }}>
        <h1 style={{ fontSize: "2.2rem", fontWeight: 700, color: "#111D4B", marginBottom: "18px" }}>
          Datenschutzerklärung
        </h1>
        <p style={{ lineHeight: 1.7, color: "#444", marginBottom: "16px" }}>
          Wir nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst. Nachfolgend informieren wir Sie darüber,
          welche Daten bei der Nutzung unserer Website erhoben, gespeichert und verarbeitet werden und welche Rechte
          Ihnen in Bezug auf Ihre Daten zustehen.
        </p>
        <p style={{ lineHeight: 1.7, color: "#444", marginBottom: "16px" }}>
          Verantwortlich für die Datenverarbeitung ist Medway Recruitment. Bei Fragen oder Auskunftsersuchen wenden Sie
          sich bitte an recruitmentmedway@gmail.com. Wir verwenden personenbezogene Daten ausschließlich zur Bearbeitung
          Ihrer Anfragen, zur Vertragsabwicklung und zur Verbesserung unseres Online-Angebots. Eine Weitergabe an Dritte
          erfolgt nur, wenn dies gesetzlich erlaubt oder zur Vertragserfüllung erforderlich ist.
        </p>
        <p style={{ lineHeight: 1.7, color: "#444", marginBottom: "16px" }}>
          Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung oder Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten sowie das Recht auf Datenübertragbarkeit. Darüber hinaus steht Ihnen ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
        </p>
        <p style={{ lineHeight: 1.7, color: "#444" }}>
          Diese Datenschutzerklärung wird bei Bedarf aktualisiert. Bitte prüfen Sie daher regelmäßig, ob es Änderungen
          gegeben hat.
        </p>
      </Container>
    </>
  );
}

export default Datenschutz;
